module.exports = __webpack_public_path__ + "static/media/1.8_preview.fbfbca52.png";